import type { ISendEfaxRequest } from "../../../core/ports/driver/VisitNotesService";

export const buildSendEfaxFormData = (request: ISendEfaxRequest): FormData => {
  const formData = new FormData();
  formData.append("file", request.file, request.filename);
  if (request.efaxEmail) {
    formData.append("efax_email", request.efaxEmail);
  }
  formData.append("patient_name", request.patientName);

  if (request.noteId != null) {
    formData.append("note_id", request.noteId.toString());
  }

  if (request.patientId != null) {
    formData.append("patient_id", request.patientId.toString());
  }

  if (request.attachmentFilenames?.length) {
    formData.append(
      "attachment_filenames",
      JSON.stringify(request.attachmentFilenames)
    );
  }

  if (request.body) {
    formData.append("body", request.body);
  }

  if (request.method) {
    formData.append("method", request.method);
  }

  if (request.includeCoverPage !== undefined) {
    formData.append(
      "include_cover_page",
      request.includeCoverPage ? "true" : "false"
    );
  }

  return formData;
};
